import { Resource } from 'react-admin'
import { debug } from '../test'
import { Permissions } from '../types/apiTypes'
import conversations from './Conversation'

const availableResources = ({scopes}: Permissions): JSX.Element[] => [
  <Resource
    key="conversation"
    name="conversation"
    options={{
      label: 'Gesprekken',
      scopes: ['labs:all']
    }}
    list={conversations.list}
    show={conversations.show}
    icon={conversations.icon}
  />,
]

const fallback = (): JSX.Element[] => [
  <Resource
    key="conversation"
    name="conversation"
    options={{
      label: 'Gesprekken',
    }}
    list={conversations.list}
    icon={conversations.icon}
  />
]

export const resourcesForScopes = ({ scopes }: Permissions): JSX.Element[] => {
  debug && console.log({scopes})
  if (!scopes || scopes.length === 0) {
    console.warn('No scopes received, returning fallback resource')
    return fallback()
  }
  const resources = availableResources({ scopes })
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
    .filter(resource => resource.props.options.scopes.find(scope => scopes.includes(scope)) !== undefined)
  if (!resources || resources.length === 0) {
    console.warn('No resources received, returning fallback resource')
    return fallback()
  }
  return resources
}
